module.exports = __webpack_public_path__ + "static/img/zanwuE.ee8759e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zanwuE.png
// module id = ynCj
// module chunks = 1